// extracted by mini-css-extract-plugin
module.exports = {"App":"App_App__2mfU8","AppLogo":"App_AppLogo__3dIEJ","App-logo-spin":"App_App-logo-spin__3MWjw","AppHeader":"App_AppHeader__1PtQ3","AppLink":"App_AppLink__12a0u"};